/* v3: smooth accordions (info dropdowns + FAQ) */
(function(){
var rm=window.matchMedia('(prefers-reduced-motion: reduce)').matches,EASE='cubic-bezier(.4,0,.2,1)';
document.querySelectorAll('details.acc').forEach(function(d){
var s=d.querySelector('summary'),anim=null,closing=false;
s.addEventListener('click',function(e){
if(rm)return;e.preventDefault();
if(anim){anim.cancel();anim=null;}
var start=d.offsetHeight+'px';
if(!d.open||closing){
closing=false;d.open=true;d.classList.add('vv-opening');
var end=d.offsetHeight+'px';
anim=d.animate({height:[start,end]},{duration:Math.min(700,350+d.offsetHeight*0.6),easing:EASE});
}else{
closing=true;var end2=s.offsetHeight+'px';
anim=d.animate({height:[start,end2]},{duration:Math.min(600,300+d.offsetHeight*0.5),easing:EASE});
}
var me=anim;me.onfinish=function(){if(anim!==me)return;if(closing){d.open=false;closing=false;}d.classList.remove('vv-opening');anim=null;};
});
});
})();
